import { useState } from 'react';
import Statement from './Statement.jsx';
import { TransactionForm } from './Shareholders.jsx';
import { useApi } from '../lib/hooks.js';
import { useToast } from '../lib/toast.jsx';
import { t } from '../lib/i18n.js';
import { IconExchange } from '../components/Icons.jsx';

/**
 * The per-shareholder statement. Same shared statement page every other party
 * type uses; the header action opens the kind-aware transaction form instead
 * of the generic payment form, since a shareholder's balance never moves
 * through a plain payment - see ExchangeStatement.jsx for the same pattern.
 */
export default function ShareholderStatement() {
  const [open, setOpen] = useState(false);
  const shareholders = useApi('/api/shareholders', { include_inactive: true });
  const toast = useToast();

  return (
    <Statement
      type="shareholder"
      headerAction={({ party, reload }) =>
        party && (
          <>
            <button type="button" className="btn btn-sm btn-primary no-print" onClick={() => setOpen(true)}>
              <IconExchange /> {t.shareholder.newTransaction}
            </button>
            {open && (
              <TransactionForm
                shareholders={shareholders.data || []}
                initialShareholderId={party.id}
                onClose={() => setOpen(false)}
                onSaved={() => {
                  setOpen(false);
                  toast.success(t.shareholder.transactionSaved);
                  reload();
                }}
              />
            )}
          </>
        )
      }
    />
  );
}
